import { Spin } from 'antd';
import { CustomModal } from './ScenarioColumnEditModal';
import { LoadingOutlined } from '@ant-design/icons';

type PopupProps = {
    open: boolean;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmitClick: () => void;
    loading: boolean;
    title?: string;
    subTitle?: string;
};

const DeleteConfirmationModal = ({
    open,
    onCancel,
    loading,
    onSubmitClick,
    title = 'Delete Scenario',
    subTitle = 'Are you sure you want to delete the scenario?',
}: PopupProps) => {
    return (
        <CustomModal
            width={400}
            cancelButtonProps={{ style: { borderRadius: 6 } }}
            onCancel={(e) => {
                if (loading) return;
                onCancel(e);
            }}
            onOk={() => {
                if (loading) return;
                onSubmitClick();
            }}
            title={title}
            centered
            open={open}
            okButtonProps={{ danger: true, ghost: true, style: { borderRadius: 6 } }}
            okText={loading ? <Spin indicator={antIcon} /> : 'Yes'}
        >
            <p className="pl-2">{subTitle}</p>
        </CustomModal>
    );
};
export default DeleteConfirmationModal;

export const antIcon = <LoadingOutlined style={{ fontSize: 18, color: 'red' }} spin />;
